import * as ScrollMagic from "scrollmagic";
import { gsap, TweenMax, TimelineMax, TweenLite } from "gsap"; // What to import from gsap
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import { ScrollMagicPluginIndicator } from "scrollmagic-plugins";

ScrollMagicPluginIndicator(ScrollMagic);
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

// Все подписанные элкмкнты доступны
window.addEventListener('load', function () {
    let tween = TweenMax.fromTo(
        ".js-cloud-opacity-animation",
        {
            opacity: 0,
            top: -50
        },
        {
            opacity: 1,
            top: 0,
            duration: 1
        }
    );


    let tween2 = TweenMax.fromTo(
        "#js-cloud-scale-animation",
        {
            scale: 0
        },
        {
            scale: 1,
            duration: 1,
            ease: "back",
        }
    );

    let displayObjects = [tween, tween2];
    for (let i = 0; i < displayObjects.length; i++) {
        displayObjects[i].pause();
    }


    let is_paly = false;
    let controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({ triggerElement: "#js-trigger-cloud", offset: -50 })
        .addTo(controller)
        .on("start end", (e) => {
            if (!is_paly) {
                is_paly = true;
                for (let i = 0; i < displayObjects.length; i++) {
                    displayObjects[i].play();
                }
            }
        });


    // Перемигивание блюром
    let containers = gsap.utils.toArray(".upsd-cloud-bl__char");
    containers.forEach(function (container, i) {
        setTimeout(() => {
            setInterval(() => {
                container.classList.add('upsd-cloud-bl__char_blur');
                setTimeout(() => {
                    container.classList.remove('upsd-cloud-bl__char_blur');
                }, 600);
            }, 5000);
        }, 200 * i);
    });
    // /Перемигивание блюром



});